import type {ReactNode} from "react";
import {useTranslation} from "react-i18next";

interface LoadingIndicatorProps {
    /** only show loading indicator, if loading is true */
    loading: boolean;
    /** optional class name for the messages. If missing, the message will be full-width. */
    className?: string;
}

/**
 * Indicator, that data is still being loaded.
 */
function LoadingIndicator({loading, className}: LoadingIndicatorProps): ReactNode {
    const {t} = useTranslation();

    if (!loading) return null;

    const classNameFixed = "grow flex flex-col justify-center items-center";
    const classNameEffective = typeof className !== "string" ? classNameFixed : `${classNameFixed} ${className}`;

    return (
        <div className={classNameEffective}>
            <div className="pi pi-spin pi-spinner text-8xl" />
            <div className="text-4xl mt-6">{t("general.loading")}</div>
        </div>
    );
}

export default LoadingIndicator;
